import React from 'react';
import { CategoriesData } from './CategoriesData';
import './Categories.css';

const Categories = () => {

    return (
        <section className='lg:pt-[130px] pt-3 lg:px-[100px] px-4 gradient-bg'>
            <h2 className='text-2xl font-bold mb-10'><span className='text-underline'>Most Populer</span> Categories</h2>
            <div className='categories-container'>
                {
                    CategoriesData.map((category, index) =>
                        <div className='category-container cursor-pointer'>
                            <ul className='text'>
                                <img src={category.img} alt="" />
                                <li className='lg:pt-6 pt-4 font-[500] lg:text-sm text-[10px] '>
                                    {category.name}
                                </li>
                            </ul>
                        </div>
                    )
                }
            </div>
        </section>
    );
};

export default Categories;